<template>
  <div class="home-tracks-track col-xs-6 col-md-6 col-lg-3">
    <div class="box" :v-key="this.data.slug">
        <a :href="getLink" v-on:click="goLink($event)" class="image-link">
          <Album :track="data" />
        </a>
        <div class="info">
            <h3 class="artist"><a :href="getLink" v-on:click="goLink($event)">{{ data.artist }}</a></h3>
            <a :href="getLink" v-on:click="goLink($event)" class="title">{{ data.title }}</a>
        </div>
        <div class="free" v-if="!this.data.pre_save_spotify">
            <a :href="getLink" v-on:click="goLink($event)" v-text="freeText"></a>
            <a :href="getLink" v-on:click="goLink($event)" v-text="freeText" class="hover"></a>
        </div>
    </div>
  </div>
</template>

<script>

import Album from '@/components/Album'

export default {
  name: 'TracksTrack',
  dependencies: ['DATA'],
  props: ['data'],
  components: {
    Album
  },
  computed: {
    freeText () {
      return (this.data.free) ? this.DATA.configs.tracks.free : this.DATA.configs.tracks.buy
    },
    getLink () {
      if (this.data.pre_save_spotify) {
        return this.data.pre_save_spotify;
      }
      return (this.data.link) ? this.data.link : this.data.slug
    }
  },
  data () {
    return {
      canvasWidth: 0,
      position: {
        value: 0
      },
    }
  },
  methods: {
    goLink ($event) {
      fbq('track', 'clickTrack', { artist: this.data.artist, song: this.data.title });
      if (!this.data.link && !this.data.pre_save_spotify) {
        if ($event) $event.preventDefault()
        this.$bus.$emit('track-open', this.data)
      }
    },
    onResizeWindow () {
      this.canvasWidth = this.$refs.imgCanvas.getBoundingClientRect().width
    },
  },
  beforeDestroy () {
    window.removeEventListener('resize', this.onResizeWindow)
  },
  mounted () {
  }
}
</script>

<style lang="scss">
  @import '../../../scss/variables';
  .home-tracks-track {
    transition: transform 1s $easeInOutExpo;
    opacity: 0;
    animation: track-entrance 0.5s $easeInOutQuint forwards;


    @keyframes track-entrance {
      from {
        transform: translate3d(0px, 40px, 0px);
        opacity: 0;
      }
      to {
        transform: translate3d(0px, 0px, 0px);
        opacity: 1;
      }
    }

    @for $i from 1 through 40 {
      &:nth-child(#{$i}) {
        animation-delay: $i * 0.05s;
      }
    }
    // &:hover {
    //   transform: scale(1.05);
    //   a {
    //     color: $purple !important;
    //   }
    // }
    .image {
      width: 100%;
      transition: transform 0.5s $easeOutQuint;
    }

    a.image-link {
      width: 100%;
      display: block;
      overflow: hidden;
      background: $purple;
      &:after {
        content: "";
        width: 100%;
        display: block;
        height: 10px;
        background: white;
        margin-top: -3px;
      }
      canvas {
        top: 0px;
        margin-left: 0.5rem;
        margin-right: 0.5rem;
        position: absolute;
        left: 0px;
        width: calc(100% - 1rem);
      }
    }

    .info {
      color: #272725;
      float: left;
      width: 80%;
      height: auto;
      padding-bottom: 40px;
      a {
        width: 100%;
        display: block;
        color: $black;
        text-decoration: none;
      }
      .artist {
        font-size: 16px;
        font-family: $font-bold;
        letter-spacing: -.5px;
        padding-bottom: 3px;
        padding-right: 5%;
        text-transform: uppercase;
        display: block;
        position: relative;
        float: left;
        clear: both;
        a {
          // transition: transform 0.3s $easeInOutQuint, opacity 0.3s linear;
          transition: color 0.3s linear;
        }
        @media screen and (max-width: 64em) {
          font-size: 11px;
        }
      }
      .title {
        font-size: 13px;
        display: block;
        position: relative;
        float: left;
        transition: color 0.3s linear;
        @media screen and (max-width: 64em) {
          font-size: 7px;
        }
      }
      @media screen and (max-width: 64em) {
        width: 74%;
      }
    }
    .free {
      a {
        color: #272725;
        text-transform: uppercase;
        position: absolute;
        transition: transform 0.7s $easeInOutQuint, opacity 0.3s linear;
      }
      a.hover {
        color: $purple;
        transform: translate3d(0px, 15px, 0px);
        opacity: 0;
      }
      border-left: 1px solid #e5e5e5;
      transition: border 0.3s linear;
      float: left;
      width: 19%;
      height: 3em;
      text-align: center;
      font-size: 9px;
      font-family: $font-bold;
      // padding-top: 11px;
      display: flex;
      align-items: center;
      justify-content: center;
      @media screen and (max-width: 64em) {
        font-size: 7px;
        width: 25%;
      }
    }

    &:hover {
      .image {
        transform: scale(0.98);
      }
      .artist:not(.purple) {
        a {
          color: $purple;
        }
      }
      .title {
        color: $purple;
      }
      .free {
        border-left: 1px solid $purple;

        a:not(.hover) {
          transform: translate3d(0px, -15px, 0px);
          opacity: 0;
        }
        a.hover {
          transform: translate3d(0px, 0px, 0px);
          opacity: 1;
        }
      }      
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/home/Tracks/Track.vue